<script setup lang="ts">
import { Ref, ref } from "vue";
import { useI18n } from "vue-i18n";
import { titleInputRules } from "@/ui/validation/validationRules";
import { useApiClient } from "@/api/client";
import { toastApiResult } from "@/toaster";
import router from "@/router/router";
import CreateSegmentExportScheduleDTO = App.Data.ExportScheduler.CreateSegmentExportScheduleDTO;
const isDialogVisible = defineModel<boolean>();

const { t } = useI18n();

const { segment_uuid } = defineProps<{
	segment_uuid: string;
}>();

const scheduleToSave: Ref<CreateSegmentExportScheduleDTO> = ref({
	title: "",
	segment_uuid: segment_uuid,
});

const isFormValid: Ref<boolean> = ref(false);

const createSchedule = async () => {
	const response = await toastApiResult(
		useApiClient("exportSchedules").createFromSegmentBuilder(
			scheduleToSave.value
		)
	);
	if (response.isOk()) {
		isDialogVisible.value = false;
		router.push(`/scheduler/${response.value.uuid}`);
	}
};
</script>

<template>
	<v-dialog v-model="isDialogVisible" persistent width="60vw">
		<v-form v-model="isFormValid">
			<v-card elevation="9">
				<v-toolbar>
					<v-toolbar-title>
						<i class="fa-duotone fa-calendar-clock fa-lg mr-3"></i>
						New scheduled export
					</v-toolbar-title>
					<v-spacer />

					<v-btn icon @click="isDialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-divider style="border-color: unset !important" />
				<div class="px-4 pt-4">
					<div class="pa-2">
						<v-text-field
							label="Title"
							:min-width="200"
							variant="filled"
							placeholder="Title name"
							v-model="scheduleToSave.title"
							:rules="titleInputRules(t)"
						/>
					</div>
				</div>

				<v-divider style="border-color: unset !important"></v-divider>

				<v-card-actions class="mx-5 my-2">
					<v-spacer></v-spacer>
					<v-btn
						text="Cancel"
						variant="text"
						@click="isDialogVisible = false"
					></v-btn>
					<v-btn
						text="Next"
						@click="createSchedule()"
						:disabled="isFormValid === false"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<style lang="scss"></style>
